import React from "react";
import { Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

function InstallPage() {
  const navigate = useNavigate();

  return (
    <Container className="mt-5 text-center">
      <h2>Install Prayers In Silence</h2>
      <p>This app can be installed on your device for quick access.</p>

      <h5>📱 On Android:</h5>
      <p>Tap the three-dot menu in Chrome and select “Add to Home screen.”</p>

      <h5>🍎 On iPhone:</h5>
      <p>Tap the Share icon in Safari and choose “Add to Home Screen.”</p>

      <div
        className="glass-button bg-transparent border-0 w-25 text-center mx-auto d-block mt-4"
        onClick={() => navigate("/")}
        title="Back to Home"
      >
        🏠
      </div>
      <p className="mt-3">
  💡 You don’t need to install anything to use Prayers In Silence. The live version works perfectly in your browser anytime.
</p>

<p className="mt-2">
  ⚠️ This app is provided as-is. While it has been tested on multiple devices, installation and performance may vary depending on your browser and operating system. By installing, you acknowledge that you do so at your own discretion.
</p>


    </Container>
  );
}

export default InstallPage;